import Utils from "../../../common/utils";

import couponTypeEnum from '../../data/couponTypeEnum';

// util
import numberHelper from '../../util/numberHelper';

export default {
    data : {
        currencyType : '￥',
        price : 0,
        product : {
            id : '',
            title : '',
            image : '',
            price : '',
        },
        status : '',
        payStatus:false,
        orderId:'',
        couponList : [],
        selectedCoupon : null,
        couponTypeEnum : couponTypeEnum,

        agreeServiceProtocol : false,
    },
    methods : {

        loadCouponList : function () {

            addConsoleLog('load coupon list.');
            var me = this;
            $.ajax({
                url : this.apiConfig.couponList.url,
                type : this.apiConfig.couponList.method || 'get',
                data : this.apiConfig.couponList.params || {},
                success : function (result) {
                    me.couponList = result.data;

                    // do not auto select first coupon
                    // if (me.couponList && !me.selectedCoupon)
                    // {
                    //     me.selectedCoupon = me.couponList[0];
                    // }

                },
                error : app.config.ajaxErrorHandle
            });
        },

        setProduct : function (productData) {
            for (var key in productData)
            {
                this.product[key] = productData[key];
            }

            this.apiConfig.couponList.params.bizId = productData.id || '';
            this.apiConfig.couponList.params.sourcePrice = productData.price || '';
            this.loadCouponList();
            this.calculatePrice();
        },

        clickCoupon : function (couponItem) {
            if (!couponItem.isUse)  // can not use
            {
                return;
            }
            this.selectedCoupon = couponItem;
            this.currentContent = this.contents.pay;
            this.calculatePrice();
        },

        calculatePrice : function () {

            if (!this.product)
            {
                this.price = 0;
                return;
            }

            if (this.selectedCoupon)
            {
                this.price = this.selectedCoupon.afterDiscountAmount;
            }
            else
            {
                this.price = this.product.price;
            }
        },

        onPaySuccess : function (result) {},

        pay : function () {
            var me = this;

            if( !this.agreeServiceProtocol){
                app.showMessageBox('请先勾选服务协议');
                return;
            }

            this.submitOrder(function(result){

                var payWay = Utils.getPayWay();
                var data = result.data;
                var orderId = data.orderId;

                if (typeof (data.jssdkPayConfig) === 'undefined')
                {
                    // not need pay
                    me.onPaySuccess(data, orderId);
                    return;
                }

                var payParams = data.jssdkPayConfig;

                me.orderId = orderId;
                var ua = window.navigator.userAgent.toLowerCase();

                // 微信小程序环境
                // if(ua.match(/MicroMessenger/i) == 'micromessenger')
                // {
                //     wx.miniProgram.getEnv(function(res) {
                //         if (res.miniprogram) {
                //             // 小程序环境下逻辑
                //             var pid=(payParams.package).split('=')[1];
                //             var params = '?timeStamp='+payParams.timestamp
                //                 +'&package='+pid
                //                 +'&paySign='+payParams.paySign
                //                 +'&signType='+payParams.signType
                //                 +'&nonceStr='+payParams.nonceStr;
                //             var payurl='/pages/wxpay/wxpay'+params;
                //             wx.miniProgram.navigateTo({url: payurl});
                //         }
                //     });
                // }

                if (payWay === 'H5')
                {
                    wx.chooseWXPay({
                        timestamp: payParams.timestamp,// 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: payParams.nonceStr, // 支付签名随机串，不长于 32 位
                        package: payParams.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                        signType: payParams.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: payParams.paySign, // 支付签名
                        success: function (res) {// 支付成功, res 示例值 {"errMsg": "chooseWXPay:ok"}
                            me.getPayStatus(orderId, function (result) {
                                // window.location.href = './download/paySuccess.html?id=' + orderId
                                me.onPaySuccess(result, orderId);
                            });
                        },
                        cancel: function (res) {// 支付取消, res 示例值 {"errMsg": "chooseWXPay:cancel"}

                        },
                        fail: function (res) {// 支付失败, res 示例值 {"errMsg": "chooseWXPay:fail"}
                            app.showMessageBox("支付失败: " + res.errMsg);
                        },
                        complete: function (res) {// 不管什么状态, 最终都会调用

                        }
                    });
                }
                // else if (payWay === 'SCAN')
                // {
                    // var _code = $('#code');
                    // $('.pay-code').show();
                    // var codeWidth = _code.width();
                    // var codeHeight = _code.height();
                    // $('#code').qrcode({
                    //     render: "canvas",//设置渲染方式
                    //     width: codeWidth,     //设置宽度
                    //     height: codeHeight,     //设置高度
                    //     text: result.codeUrl
                    // });
                    // vodPay.action.getPayStatus.req(result.orderId);
                // }
                // else if (payWay === 'IOS')
                // {
                //     return window.webkit.messageHandlers.jsCallNativeVodPay.postMessage(JSON.stringify(result));
                // }
                // else if (payWay === 'ANDROID')
                // {
                //     return window.contact.jsCallNativeVodPay(JSON.stringify(result));
                // }

            });
        },

        submitOrder : function (callback)
        {
            var me = this;

            var promotionCode = $.cookie('promotion_from') || '';

            if (this.status === 'loading')
            {
                console.info('already loading.');
                return;
            }

            // submit order
            this.status = 'loading';
            let adId = getSessionData('ad_sessino_key');

            var url     = this.apiConfig.submitOrder.url;
            var method    = this.apiConfig.submitOrder.method || 'get';
            var idName  = this.apiConfig.submitOrder.idName || 'id';

            var data = {
                payWay: Utils.getPayWay(),
                promotionCode : promotionCode,
                adId: adId,
                couponNo: this.selectedCoupon ? this.selectedCoupon.couponId : null,
            };
            data[idName] = me.product.id;

            $.ajax({
                url : url,
                type : method,
                data: data,
                success: function (result) {

                    if (result.errorCode) {
                        app.showMessageBox(result.msg);
                        return;
                    }

                    if (callback)
                    {
                        callback(result);
                    }
                },
                error : app.config.ajaxErrorHandle,
                complete : function () {
                    me.status = 'complete';
                }
            });
        },
        getPayStatus : function (orderId, callback)
        {
            var me = this;
            me.status = 'loading';

            $.ajax({
                url: this.apiConfig.getPayStatus.url,
                type : this.apiConfig.getPayStatus.method || 'GET',
                data: {
                    orderId: orderId
                },
                success: function (result){

                    me.payStatus = true;

                    if (result.errorCode) {

                        addErrorLog(result.msg);

                        // errorCode 为1，忽略
                        if (result.errorCode != 1)
                        {
                            app.showMessageBox(result.msg);
                            return;
                        }
                    }

                    if (callback)
                    {
                        callback(result);
                    }
                },
                error : app.config.ajaxErrorHandle,
                complete : function () {
                    me.status = 'complete';
                }
            });
        }
    },
    mounted : function() {
        this.currentContent = this.contents.pay;
    }
}




/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/content_module/payComp.js
 **/